import type { FC } from "react";

import { Button, type ButtonProps } from "./Button";
import { Dialog, type DialogProps } from "./Dialog";

import { t } from "i18n/i18n";

type ConfirmationDialogProps = DialogProps & {
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonKind?: ButtonProps<"button">["kind"];
  onConfirm?: () => void;
};

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  onClose,
  children,
  cancelButtonText = t("common.cancel"),
  confirmButtonText = t("common.confirm"),
  confirmButtonKind = "blue",
  onConfirm = () => {},
  ...props
}) => (
  <Dialog onClose={onClose} {...props}>
    <>
      {children}

      <div className="flex justify-end gap-2">
        <Button
          eventName="Confirmation modal - Cancel"
          kind="white"
          size="m"
          title={cancelButtonText}
          onClick={onClose}
        >
          {cancelButtonText}
        </Button>

        <Button
          eventName="Confirmation modal - Confirm"
          kind={confirmButtonKind}
          size="m"
          title={confirmButtonText}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmButtonText}
        </Button>
      </div>
    </>
  </Dialog>
);
